import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum ProductFields {
    CUSTOM_ID = 'customId',
    CUSTOM_ID_SCHEME = 'customIdScheme',
    TYPE = 'type',
    NAME = 'name',
    INVOICE_ITEM_NAME = 'invoiceItemName',
    ACTIVITY_PERMISSIONS = 'activityPermissions',
    /** Guards changing activityPermissions[].lessonFormat (shrd ProductFields); reading comes with ACTIVITY_PERMISSIONS */
    LESSON_FORMAT = 'lessonFormat',
    INTERVAL = 'interval',
    CATEGORIES = 'categories',
    BASIS = 'basis',
    NET_PRICE = 'netPrice',
    GROSS_PRICE = 'grossPrice',
    VAT_PERCENT = 'vatPercent',
    VAT = 'vat',
    COST = 'cost',
    IS_VIRTUAL = 'isVirtual',
    SHIPMENT = 'shipment',
    IS_ACTIVE = 'isActive',
    PRICE_BASIS = 'priceBasis',
    LEGACY_REF = 'legacyRef',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ProductFields {
    export type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ProductFields, Data> = {
        [ProductFields.CUSTOM_ID]: {
            text: 'Produkt-ID',
            readOnly: true,
        },
        [ProductFields.CUSTOM_ID_SCHEME]: {
            text: 'ID-Schema',
            readOnly: true,
        },
        [ProductFields.TYPE]: {
            text: 'Typ',
            readOnly: true,
        },
        [ProductFields.NAME]: {
            text: 'Name',
        },
        [ProductFields.INVOICE_ITEM_NAME]: {
            text: 'Bezeichnung auf Rechnung',
        },
        [ProductFields.ACTIVITY_PERMISSIONS]: {
            text: 'Kurszulassungen',
        },
        [ProductFields.LESSON_FORMAT]: {
            text: 'Unterrichtsformat (je Kurszulassung)',
        },
        [ProductFields.INTERVAL]: {
            text: 'Intervall',
        },
        [ProductFields.CATEGORIES]: {
            text: 'Kategorien',
        },
        [ProductFields.BASIS]: {
            text: 'Preis-Basis',
        },
        [ProductFields.NET_PRICE]: {
            text: 'Nettopreis',
        },
        [ProductFields.GROSS_PRICE]: {
            text: 'Bruttopreis',
        },
        [ProductFields.PRICE_BASIS]: {
            text: 'Preis-Basis',
        },
        [ProductFields.VAT_PERCENT]: {
            text: 'MwSt. in %',
        },
        [ProductFields.VAT]: {
            text: 'MwSt.',
        },
        [ProductFields.COST]: {
            text: 'Kosten',
        },
        [ProductFields.IS_VIRTUAL]: {
            text: 'Ist virtuell?',
        },
        [ProductFields.SHIPMENT]: {
            text: 'Versand',
        },
        [ProductFields.IS_ACTIVE]: {
            text: 'Ist aktiv?',
        },
        [ProductFields.CREATED_AT]: {
            text: 'Erstellt am',
            readOnly: true,
        },
        [ProductFields.UPDATED_AT]: {
            text: 'Aktualisiert am',
            readOnly: true,
        },
        [ProductFields.LEGACY_REF]: {
            text: 'Legacy-Referenzen',
        },
    };

    export const Items = mapRecordToItems(Record);
}
